import { Input, NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CertificateDownloadRoutingModule } from './certificate-download-routing.module';
import { CertificateDownloadComponent } from './certificate-download.component';
import { CertificateNo1Component } from './certificate-no1/certificate-no1.component';
import { CertificateNo2Component } from './certificate-no2/certificate-no2.component';


@NgModule({
  declarations: [
    CertificateDownloadComponent,
    CertificateNo1Component,
    CertificateNo2Component
  ],
  imports: [
    CommonModule,
    CertificateDownloadRoutingModule
  ],exports:[
    CertificateDownloadComponent,
    CertificateNo1Component,
    CertificateNo2Component
  ]
})
export class CertificateDownloadModule{
 
 }
